import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
@Directive({ selector: '[capitalFirstLetter]' })
export class CapitalFirstLetterDirective implements OnInit {
  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    this.el.value = this.capitalFirstLetter(this.el.value);
  }

  @HostListener('input', ['$event.target.value'])
  onKeyDown(value) {
    this.el.value = this.capitalFirstLetter(value);
  }

  capitalFirstLetter(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }
}
